<script setup lang="ts">
definePageMeta({
  name: 'podcast',
})

const route = useRoute<'podcast'>()

const { data: currentPodcast, suspense } = usePodcast(computed(() => route.params.slug))

await suspense()

if (currentPodcast.value) {
  provide(keys.currentArticle, currentPodcast.value)
} else {
  throw createError({
    status: 404,
    message: 'Podcasten finnes ikke',
  })
}

useDocumentSeo(currentPodcast.value)
</script>

<template>
  <div>
    <LayoutBreadCrumbs
      :background="true"
      :text-conversions="{ [route.params.slug]: currentPodcast?.title }"
    />
    <UiArticlesContent />
  </div>
</template>
